export default function PageHeader({ title, subtitle, children }) {
  return (
    <div className="px-8 py-6 border-b border-slate-200 bg-white">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-emerald-600 mb-1">
            AMAL VBC
          </div>
          <h1 className="font-barlow font-bold text-3xl sm:text-4xl tracking-tight text-slate-900 leading-none">
            {title}
          </h1>
          {subtitle && <p className="text-sm text-slate-500 mt-2">{subtitle}</p>}
        </div>
        <div className="flex items-center gap-2">{children}</div>
      </div>
    </div>
  );
}
